function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#CCC",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.082 15.012c1.758-.651 3.052-1.644 3.882-2.979.83-1.334 1.245-2.88 1.245-4.638 0-1.27-.277-2.32-.83-3.15-.553-.83-1.4-1.245-2.54-1.245-.846 0-1.562.269-2.148.806-.586.537-.879 1.196-.879 1.977 0 .423.09.814.27 1.172.178.358.406.667.683.928.276.26.594.456.952.586.358.13.732.146 1.123.049l.586-.196c.195-.065.366-.065.512 0 .147.065.22.277.22.635 0 1.074-.309 2.05-.928 2.93-.618.879-1.578 1.595-2.88 2.148l.732.977zm-7.812 0c1.757-.651 3.051-1.644 3.881-2.979.83-1.334 1.245-2.88 1.245-4.638 0-1.27-.276-2.32-.83-3.15C7.013 3.415 6.166 3 5.027 3c-.846 0-1.562.269-2.148.806C2.293 4.343 2 5.002 2 5.783c0 .423.09.814.269 1.172.179.358.406.667.683.928.277.26.594.456.952.586.358.13.733.146 1.123.049l.586-.196c.196-.065.366-.065.513 0 .146.065.22.277.22.635 0 1.074-.31 2.05-.928 2.93-.619.879-1.563 1.595-2.832 2.148l.684.977z",
  transform: "translate(-170 -319) translate(20 231) translate(151 88)"
})))));

function SvgQuotesEndGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesEndGray);
export default __webpack_public_path__ + "static/media/quotes-end-gray.8024a857.svg";
export { ForwardRef as ReactComponent };